module.exports = __webpack_public_path__ + "static/media/icon_outsource.cb19d88a.svg";